const ProgramsActionTypes = {
  SET_TAB_DATA: "SET_TAB_DATA",
};
export default ProgramsActionTypes;
